import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { InputErrorService } from 'src/app/global/services/input-errors.service';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';


@Injectable()
export class InputErrorProvider extends InputErrorService {

    constructor(private tagManagerService: TagManagerService) {
        super();
    }

    validarError(paso: string, campo: AbstractControl): void {

        const data: any = campo.errors;
        if (data === null) {
          return;
        }

        if (data.dniInvalid) {
          this.tagManagerService.logError(paso, 'Rut Inválido', 'Rut no es válido');
        }

        if (data.serieLength) {
          this.tagManagerService.logError(paso, 'Serie Inválido', 'Serie documento no es válido');
        }



    }
}
